import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/freshsales-request-a-demo-form/freshsales-request-a-demo-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/testimonials/testimonials.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/light-gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/tick.svg");
